//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
let d=[[[0,"AssociativityEnumType",1,1],[0,"AssociativityToggle",1,1],[0,"FileBrowser",1,1],[0,"Inputs",1,1],[0,"Location",1,1],[0,"SettingsToggle",1,1],[0,"Worksheet",1,1]],[[["num_expressions"],"GetExpressions",{R_:{expressions:"Expression[]"}},0,1],[["expressions"],"SetExpressions",{},1,1],[["num_names"],"GetMaplenames",{R_:{names:""}},0,1],[["names"],"SetMaplenames",{},1,1]],[]];
SPLM.Features.MapleBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.MapleBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.MapleBuilder.LocationType = Object.freeze({
    "OperatingSystem" : "OperatingSystem", "Teamcenter" : "Teamcenter"});

SPLM.Features.MapleBuilder.AssociativityEnum = Object.freeze({
    "None" : "None", "New" : "New", "Existing" : "Existing"});

export default SPLM;